import React from "react";
import './App.css';
import Home from './Component/Home/Home';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Skills from "./Component/Skills/Skills";
import NotFound from "./Component/NotFound.js/NotFound";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path='/'>
          <Home />
          <footer>
            <p>&copy; Copyright | Sudipta Acharjee</p>
          </footer>
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
